import { APPROVAL_TYPES_FETCH_TYPES } from '../action-types/approval-types';
import { axiosAction } from '../../utils/axiosAction';

const ENDPOINT = `${process.env.REACT_APP_ENDPOINT_APPROVAL_TYPES}`;

export const getEntities = (brand, meta?) => async dispatch => {
  return axiosAction.get(
    `${ENDPOINT}?brand=${brand}`,
    APPROVAL_TYPES_FETCH_TYPES,
    dispatch,
    { meta },
  );
};
